import HttpBaseService from '@/services/http/HttpBaseService'

class ApiSessionService extends HttpBaseService {

  setCookie = () => {
    return this.executeRequest('/api/csrf-cookie', 'GET')
  }
}

export default new ApiSessionService()
